module.exports = __webpack_public_path__ + "img/DAY5-1.f290ffe2.jpg";